module.exports = __webpack_public_path__ + "static/media/Segmentation-3.bff3da1b.png";